export default __webpack_public_path__ + "static/media/img3.08426566.jfif";